import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { COLOR_GREY_400, COLOR_PRIMARY_1 } from 'src/colors';
import BedOutlinedIcon from '@mui/icons-material/BedOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Divider from '@mui/material/Divider';
import { exchangeRates } from 'src/const';
import { abbreviateNumber, convertCurrency, updateUserEstimatorSuggestionClickInDynamoDB } from 'src/utils/functions';

const EstimatorSuggestionCard = ({
  bedrooms,
  occupancy,
  revenue,
  dailyRate,
  link,
  name,
  currency,
  setSearchBarValue,
  setCenterCoord,
  latitude,
  longitude
}) => {
  const aggregatedDetails = [
    { value: revenue, title: 'Revenue' },
    { value: occupancy, title: 'Occupancy Rate' },
    { value: dailyRate, title: 'Daily Rate' },
  ];
  return (
    <Box
      sx={{
        minWidth: '250px',
        height: '160px',
        border: `1px solid ${COLOR_PRIMARY_1}`,
        borderRadius: '10px',
      }}
    >
      <Grid container xs={12}>
        <Grid item xs={12} sx={{ padding: '10px', height: '20%' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box
              sx={{
                height: '30px',
                width: 'auto',
                borderRadius: '20px',
                border: `1px solid ${COLOR_GREY_400}`,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minWidth: '60px',
              }}
            >
              <BedOutlinedIcon />
              <Typography variant="body1">{bedrooms}</Typography>
            </Box>
            <OpenInNewIcon
              sx={{ color: COLOR_PRIMARY_1, '&:hover': { cursor: 'pointer' } }}
              onClick={() => {
                updateUserEstimatorSuggestionClickInDynamoDB()
                window.open(link, '_blank');
                // setCenterCoord({lat:latitude, lng:longitude})
                // setSearchBarValue({
                //   address: name,
                // })
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sx={{ padding: '0px 10px', height: '40%' }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 500,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
          >
            {name}
          </Typography>
        </Grid>
        <Grid container item xs={12} sx={{ height: '50%', paddingTop: '5px' }}>
          {aggregatedDetails.map(details => (
            <Grid item xs={4}>
              <Box
                sx={{
                  height: '100%',
                  width: '100%',
                  display: 'flex',
                }}
              >
                {details.title.includes('Occupancy') && <Divider orientation="vertical" />}
                <Box
                  sx={{
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <Typography variant="body1" sx={{ textAlign: 'center', fontWeight: 500 }}>
                    {!details.title.includes('Occupancy') ? exchangeRates[currency].symbol : ''}
                    {!details.title.includes('Occupancy')
                      ? abbreviateNumber(convertCurrency(currency, details.value))
                      : details.value}
                    {details.title.includes('Occupancy') ? '%' : ''}
                  </Typography>
                  <Typography variant="body2" sx={{ textAlign: 'center', fontSize: '14px' }}>
                    {details.title}
                  </Typography>
                </Box>
                {details.title.includes('Occupancy') && <Divider orientation="vertical" />}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default EstimatorSuggestionCard;
